export const colorSize = 25;
export const colorGap = 3;
export const maxColorInGroup = 11;
